__turbopack_context__.v({
  "cancelButton": "search-module-scss-module__MaNO4q__cancelButton",
  "emptyStateWrapper": "search-module-scss-module__MaNO4q__emptyStateWrapper",
  "inputWithButton": "search-module-scss-module__MaNO4q__inputWithButton",
  "inputWrapper": "search-module-scss-module__MaNO4q__inputWrapper",
  "wrapper": "search-module-scss-module__MaNO4q__wrapper",
});
